/* eslint-disable max-len */
import React, { Fragment, useRef, useState} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import { useSelector } from 'react-redux';
import { STAGE } from '../../../../../config';
import { formatAdjustedDate } from '../../../../../CommonMethods/formatDate';

const Table = ({
    pageNumber, handleOnClickSort,sortValue,searchParams,startDate,endDate,
    email}) => {
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const StudentsDirectoryList = useSelector(state => state.StudentsDirectorySlice);
    const { List } = StudentsDirectoryList 
    const urlParams = new URLSearchParams(window.location.search);

    const branchUrl = urlParams.get("sort");
    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    const handleSort = (key) => {
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }
  
    return (<>
        
        <div className='text-center absolute w-full'>Invoice Date from <span className="font-semibold">{searchParams?.get('start_date') === null ?  formatAdjustedDate(startDate) : formatAdjustedDate(searchParams?.get('start_date'))}</span> to <span className="font-semibold">{searchParams?.get('end_date') === null ?  formatAdjustedDate(endDate, true) : formatAdjustedDate(searchParams?.get('end_date'))}</span></div>
        <div className={`flex overflow-auto ${List?.data?.length < 10 ? 'pb-[62px]' : 'pb-[6px]'} scroll-bar px-1 topHeading`} id = "search-result" >
            <table aria-label="Outside Table" className="w-full auto-layout" id='admin-table'>
                <thead>
                    <tr>
                        <th id="Invoice Date" class="min-w-[135px]" onClick={() => {handleSort('date')}}>
                            <span >Invoice Date
                                <button type="button" class="pl-1.5 sortedIcon">
                                    <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "date" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                </button>
                            </span>
                        </th>
                        <th id="Student Name" class="min-w-[250px]" onClick={() => {handleSort('student_name')}}>
                            <span >Student Name
                                <button type="button" class="pl-1.5 sortedIcon">
                                    <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "student_name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                </button>
                            </span>
                        </th>
                        <th class="min-w-[150px]">
                            <span >Class, Section
                            </span>
                        </th>
                        <th id="Invoice Number" class="px-5 py-3 min-w-[120px]" onClick={() => {handleSort('invoice_number')}}>
                            <span >Invoice #
                                <button type="button" class="pl-1.5 sortedIcon">
                                    <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "invoice_number" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                </button>
                            </span>
                        </th>
                        <th class="min-w-[110px]">
                            <span class="flex items-center justify-end">Amount
                            </span>
                        </th>
                        <th class="min-w-[110px]">
                            <span class="flex items-center justify-end">Received
                            </span>
                        </th>
                        <th class="min-w-[110px]">
                            <span class="flex items-center justify-end">Due
                            </span>
                        </th>
                        <th id="Invoice Name"class="min-w-[140px]" onClick={() => {handleSort('invoice_name')}}>
                            <span >Type
                                <button type="button" class="pl-1.5 sortedIcon">
                                    <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "invoice_name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                </button>
                            </span>
                        </th>
                        <th id="AY" class="min-w-[150px]">
                            <span >AY
                            </span>
                        </th>
                        <th id="Status" class={`min-w-[150px] max-w-[80px]`}onClick={() => {handleSort('status')}}>
                            <span >Status
                                <button type="button" class="pl-1.5 sortedIcon">
                                    <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "status" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                </button>
                            </span>
                        </th>
                        {<th class={`min-w-[80px] max-w-[100px]`}>
                            <span >Action
                            </span>
                        </th>}
                    </tr>
                    <tr aria-colspan="7" class="h-1"></tr>
                            
                </thead>
                <tbody>
                    {List?.data?.map((item , index = 0) => (
                        <Fragment key={item._id}>
                            <TableBody
                                tableData={item}
                                indexNum={index}
                                pageNumber={pageNumber}
                                selectedIndex={selectedIndex}
                                setSelectedIndex={setSelectedIndex}
                                selectedRef={selectedRef}
                                lastIndex={List?.data?.length}
                                email={email}
                            />
                        </Fragment>
                    ))}
                        
                </tbody>
                {List?.data?.length === 0 && (
                    <tbody>
                        <tr>
                            <td  style={{'line-height':'100px','text-align':'start','padding-left':'500px'}} colspan="14" className="no-records-message">
                                {'No records found'}
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>

    </>
    );
}

export default Table;
